import { useTranslation } from 'react-i18next';
import { useWebBookingBranding } from '../context/WebBookingBrandingContext';
import { resolveWebPublicExperienceForLocale } from '../types/webPublicExperience';

/**
 * Enlaces legales compactos (pago / resultado) reutilizando config pública del tenant.
 */
export function WebPaymentTrustLinks() {
  const { i18n, t } = useTranslation();
  const { webPublicExperience } = useWebBookingBranding();
  const exp = resolveWebPublicExperienceForLocale(
    webPublicExperience,
    i18n.language,
  );
  const { privacyPolicyUrl, termsUrl } = exp.trust;
  if (!privacyPolicyUrl && !termsUrl) return null;
  return (
    <div
      className="wp-trust-links"
      style={{
        marginTop: '1rem',
        fontSize: '0.8125rem',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.5rem 1rem',
        justifyContent: 'center',
        opacity: 0.9,
      }}
    >
      {privacyPolicyUrl ? (
        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          {t('webUx.footer.privacy')}
        </a>
      ) : null}
      {termsUrl ? (
        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
          {t('webUx.footer.terms')}
        </a>
      ) : null}
    </div>
  );
}
